"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const RadioField_1 = tslib_1.__importDefault(require("./RadioField"));
const RadioFieldWithTooltip = (_a) => {
    var { tooltipProps } = _a, radioFieldProps = tslib_1.__rest(_a, ["tooltipProps"]);
    return (react_1.default.createElement(react_core_1.Tooltip, Object.assign({}, tooltipProps),
        react_1.default.createElement(RadioField_1.default, Object.assign({}, radioFieldProps))));
};
exports.default = RadioFieldWithTooltip;
//# sourceMappingURL=RadioFieldWithTooltip.js.map